import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetS3RagListByCustomerUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (customer: any): Promise<any> => {
        
        return await this._aiRepository.GetS3RagListByCustomer(customer);
    }
}

export const GetS3RagListByCustomerUseCaseName = "GetS3RagListByCustomerUseCaseName";